<template>
	<div class="item-os">
		<div class="card-status">
			<div class="status-inicio">
				<div class="status-termino"></div>
			</div>
		</div>
		<div class="description">
			{{ data.label }}
		</div>
	</div>
</template>
<script>
	export default {
		props: ['data'],
	};
</script>
<style scoped>
	.item-os:nth-child(1) {
		border-top: 1px solid #cecece;
	}
	.item-os {
		border-bottom: 1px solid #cecece;
		border-right: 1px solid #cecece;
		display: block;
		position: relative;
	}
	.description {
		font-size: 12px;
		padding: 10px 5px;
	}
</style>



// WEBPACK FOOTER //
// src/components/order-of-service/components/GraficMode/components/description-os.vue